import { useLang } from "../context/LanguageContext";
import { Reveal } from "./Reveal";
import { Users, GraduationCap, MessagesSquare, HeartHandshake, Globe2 } from "lucide-react";

const ICONS = [Users, GraduationCap, MessagesSquare, HeartHandshake, Globe2];

export const Pillars = () => {
  const { t } = useLang();
  const p = t.pillars;
  return (
    <section id="pillars" className="py-24 md:py-32 relative z-10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent mb-5">{p.tag}</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-6xl leading-[1.02]">{p.title}</h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {p.list.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="group h-full rounded-2xl border border-black/5 bg-surface p-7 hover:border-primary/30 hover:-translate-y-1 transition-all duration-300">
                  <span className="grid place-items-center w-12 h-12 rounded-xl bg-primary text-primary-foreground mb-6 group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                    <Icon size={22} />
                  </span>
                  <h3 className="font-display font-bold text-lg md:text-xl tracking-tight mb-2">{item.t}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{item.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
